module.exports = __webpack_public_path__ + "assets/img/elem4-ability1.8f40dd8d.gif";